export const COLOR_CATEGORIES = ["Pink", "Red", "Orange", "Yellow", "Green", "Blue", "Purple", "Black", "White",
  "Brown/Nude", "Silver/Gray", "Gold", "Multicolor"];

export const colorSlug = (c) => c.toLowerCase().replace(/[^a-z]+/g, "-");

export const MOCKUP_ACK_TEXT = "I understand that the images shown in the Custom Builder are digitally generated mockups intended to help me visualize available fabrics and design options. They are not photographs of finished products. Because each Kys Boutique piece is handmade, the finished item may vary from the mockup in fabric placement, pattern placement, proportions, details, and overall appearance. Ready-to-Ship product photos show actual completed pieces, while Custom Builder images are visual representations of what can be created.";

// Customer-facing color chips (All + 13 colors).
export function ColorFilter({ value, onChange, testid }) {
  return (
    <div data-testid={testid} className="no-scrollbar -mx-1 mt-3 flex gap-1.5 overflow-x-auto px-1 pb-1">
      {["All", ...COLOR_CATEGORIES].map((c) => (
        <button key={c} type="button" data-testid={`${testid}-${colorSlug(c)}`} aria-pressed={value === c} onClick={() => onChange(c)}
          className={`whitespace-nowrap rounded-full border px-3 py-1 text-xs transition-colors ${value === c ? "border-kys-ink bg-kys-ink text-white" : "border-kys-blush-border bg-white text-kys-charcoal hover:border-kys-accent"}`}>
          {c}
        </button>
      ))}
    </div>
  );
}
